import { dataCurta, formatarIndicador } from '../format';
import { Selo } from '../ui';
import type { Natureza } from '../types';
import type { CamadaIndicador } from './camadaIndicadores';

export const ROTULO_NATUREZA: Record<Natureza, { texto: string; tom: 'verde' | 'azul' | 'ambar' | 'cinza'; ajuda: string }> = {
  RESULTADO: { texto: 'Resultado', tom: 'verde', ajuda: 'O que a população de fato vive. Entra no índice de necessidade.' },
  ESTRUTURA: { texto: 'Estrutura', tom: 'azul', ajuda: 'Capacidade instalada (oferta de serviços). Entra no índice de necessidade.' },
  ESFORCO: { texto: 'Esforço público', tom: 'ambar', ajuda: 'Quanto o poder público gasta. Não é "bom" nem "ruim" por si só.' },
  CONTEXTO: { texto: 'Contexto', tom: 'cinza', ajuda: 'Explica a realidade, mas não mede desempenho.' },
};

/** Explica o indicador que está no mapa: o que é, de onde vem, de que ano, e como o estado se distribui. */
export function CartaoIndicador({ indic }: { indic: CamadaIndicador }) {
  const i = indic.info;
  const m = indic.mapa;
  if (!i || !m) return null;
  const nat = ROTULO_NATUREZA[i.natureza];
  const f = (v: number) => formatarIndicador(v, i.unidade, i.casas);
  const sentido = i.sentido === 'MAIOR_MELHOR' ? 'Quanto maior, melhor.' : i.sentido === 'MENOR_MELHOR' ? 'Quanto menor, melhor.' : 'Sem "melhor" ou "pior": mostra contexto ou esforço.';
  return (
    <section class="cartao-indicador" aria-label="Sobre o indicador">
      <div class="cartao-indicador-topo">
        <h3>{i.nome}</h3>
        <span title={nat.ajuda}><Selo texto={nat.texto} tom={nat.tom} /></span>
      </div>
      <p>{i.descricao}</p>
      <p class="dica">{sentido}</p>
      {m.estado && (
        <dl class="estado-stats">
          <div><dt>Menor</dt><dd>{f(m.estado.minimo)}</dd></div>
          <div><dt>Mediana</dt><dd>{f(m.estado.mediana)}</dd></div>
          <div><dt>Média</dt><dd>{f(m.estado.media)}</dd></div>
          <div><dt>Maior</dt><dd>{f(m.estado.maximo)}</dd></div>
        </dl>
      )}
      <p class="dica fonte-linha">
        Fonte: <a href={i.fonte.url} target="_blank" rel="noopener noreferrer">{i.fonte.nome}</a> ({i.fonte.orgao}) · referência {m.periodo ?? '—'}
        {i.atualizadoEm && <> · carregado em {dataCurta(i.atualizadoEm.slice(0, 10), true)}</>}
      </p>
    </section>
  );
}
